import { events } from './events';

class DOM {

  constructor() {
  }

  /**
   * Wait for when element is visible on the screen
   * @param {HTMLElement} element htmlElement
   * @return {Promise}
   */
  waitForVisibility(element) {
    return new Promise(function(resolve, reject) {

      function searching() {
        var rect = element.getBoundingClientRect();

        if (!rect) {
          return reject();
        }

        // if element is not visible at all
        if (rect.height === 0 && rect.width === 0) {
          return;
        }

        // if elements dimensions are within window, resolve
        if (rect.top <= window.innerHeight && rect.bottom >= 0 && rect.left <= window.innerWidth && rect.right >= 0) {
          events.removeResizeSubscriber(searching);
          events.removeScrollSubscriber(searching);
          return resolve();
        }
      }

      // Subscribe to some events
      events.addResizeSubscriber(searching);
      events.addScrollSubscriber(searching);
      events.waitForWindowLoad().then(function() {
        searching();
      });

      searching();
    });
  }
}

var dom = new DOM();

export { dom }
